
import { Component, Vue, Prop } from 'vue-property-decorator';
import headers from './headersPaymentLog';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import { PaymentLog } from '@/interfaces/models/PaymentLog';
import { Venue } from '@/interfaces/models/Venue';

@Component
export default class PaymentLogTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: PaymentLog[];
  @Prop({ type: Array, required: true }) public venues!: Venue[];

  get tableHeaders() {
    return headers.map((h: ColumnHeader) => ({ ...h, text: this.$t(h.text) }));
  }

  public getVenueName(venueId?: string) {
    if (!venueId) {
      return '';
    }

    const venue = this.venues.find((v) => v._id === venueId);

    return venue?.name || venueId;
  }
}
